import { Suspense, lazy } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import PrivateRoute from '@src/contexts/auth/protectedRoute';

import RootLayout from '@src/components/layout/RootLayout';
const Login = lazy(() => import('@src/pages/login/index'));
const Claim = lazy(() => import('@src/pages/claimJourney/index'));
const NotFound = lazy(() => import('@src/pages/notFound/index'));
const Layout = lazy(() => import('@src/components/layout/Layout'));

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />}>
            <Route
                index
                element={
                    <Layout>
                        <Login />
                    </Layout>
                }
            />
            <Route path="claim" element={<PrivateRoute />}>
                <Route
                    index
                    element={
                        <Layout>
                            <Claim />
                        </Layout>
                    }
                />
            </Route>
            <Route path="**" element={<NotFound />} />
        </Route>
    )
);
const Router = () => {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <RouterProvider router={router} />
            </Suspense>
        </>
    );
};

export default Router;
